let mainRoot = "https://api.olkypay.com";
const origin = document.location.origin;
if (origin.includes("localhost") || origin.includes(".olkypay.local")) {
  // you can change it to use uat
  mainRoot = "https://api.dev.olkypay.local";
} else if (origin.includes("uat")) {
  mainRoot = "https://api.uat.olkypay.com";

  // mainRoot = 'https://apidev.olkypay.com'
} else if (origin.includes("dev")) {
  mainRoot = "https://api.dev.olkypay.local";
} else if (origin.includes("test")) {
  mainRoot = "https://api.dev.olkypay.local";
}

const url = "/_settings_environment";
const options = {
  method: "GET",
  headers: {
    "Content-Type": "*/*",
    Accept: "*/*"
  }
};
let environmentServerSide = {};

try {
  const response = await fetch(mainRoot.replace(/\/$/, "") + "/" + url.replace(/^\//, ""), options);
  const rawData = await response.json();
  environmentServerSide = rawData.data;
} catch (_) {
  console.info("environmentServerSide error");
}

const handleTheme = () => {
  const clientURl = new URL(origin);
  const subdomain = clientURl.hostname.split(".")[0];

  if (!["pass", "newpass", "app"].includes(subdomain)) {
    if (sessionStorage.getItem("origin") === null && subdomain) {
      sessionStorage.setItem("origin", subdomain as string);
    }

    fetch(mainRoot.replace(/\/$/, "") + "/olkypass/partner/theme", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        sessionStorage.removeItem("origin");
        throw new Error("No theme found");
      })
      .then((responseJson) => {
        const data = responseJson;
        const style = document.createElement("style");
        style.id = subdomain + "_origin_css";
        style.textContent = data.data;
        document.head.appendChild(style);
      })
      .catch(() => {
        sessionStorage.removeItem("origin");
      });
  }
};
handleTheme();
//substitue comave style before api

export default environmentServerSide;
